/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BaseReportConfigurationForAiAgentArtifact extends models.ReportConfigurationForAiAgent {
    constructor() {
        super();
        this.setDiscriminator("BaseReportConfigurationForAiAgentArtifact");
    }

    getFixupPrototypeFunction() { return BaseReportConfigurationForAiAgentArtifact.fixupPrototype; }

    static newInstance(model: Partial<BaseReportConfigurationForAiAgentArtifact>): BaseReportConfigurationForAiAgentArtifact {
        let obj = Object.assign(new BaseReportConfigurationForAiAgentArtifact(), model);
        BaseReportConfigurationForAiAgentArtifact.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BaseReportConfigurationForAiAgentArtifact>): BaseReportConfigurationForAiAgentArtifact {
        if (!model) return null;
        return BaseReportConfigurationForAiAgentArtifact.newInstance(<BaseReportConfigurationForAiAgentArtifact> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BaseReportConfigurationForAiAgentArtifact) {
        if (!obj) return;

        models.BaseReportConfigurationForAiAgentArtifact.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BaseReportConfigurationForAiAgentArtifact): boolean {
        if (models.ReportConfigurationForAiAgent.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BaseReportConfigurationForAiAgentArtifact.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Id of the Tenant.
     */
    tenant_id: string;

    /**
     * Id of the artifact this schedule delivers.
     */
    artifact_id: string;

}
